// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__cLwsw","right":"Footer_right__1SwyS","buttons":"Footer_buttons__1VI6D"};